import { useMutation } from '@tanstack/react-query';
import { REMOVE_USER_FCM_TOKEN, REPLACE_USER_FCM_TOKEN } from '../graphql/mutations/fcm.mutations';
import { getGraphQLClient } from '../graphqlClient';

export const useReplaceUserFcmToken = () => {
  const client = getGraphQLClient();

  return useMutation({
    mutationFn: async (token: string) => {
      return client.request(REPLACE_USER_FCM_TOKEN, {
        data: {
          token,
          device_id: null,
        },
      });
    },
  });
};

export const useRemoveUserFcmToken = () => {
  const client = getGraphQLClient();

  return useMutation({
    mutationFn: async (token: string) => {
      return client.request(REMOVE_USER_FCM_TOKEN, { token });
    },
  });
};
